import { useAppSelector } from "../store/hooks";
import { isCampaignCompleted } from "../utils/campaignHelpers";

/** Get the number of addresses assigned to the ambassador. */
export const useAddressesAssignedCount = () => useAppSelector(state => {
    const ambassadorEmail = state.user.email;
    if (!ambassadorEmail) return 0;
    const campaign = state.awareness_campaign.selected.selectedAwarenessCampaign;
    if (!campaign) return 0;
    return campaign.assigned[ambassadorEmail] ?? 0;
});

/** Get the number of addresses sensitized by the ambassador. */
export const useAddressesSensitizedCount = () => useAppSelector(state => {
    const ambassadorEmail = state.user.email;
    if (!ambassadorEmail) return 0;
    const campaign = state.awareness_campaign.selected.selectedAwarenessCampaign;
    if (!campaign) return 0;
    return campaign.ambassadorVisitedCounts?.[ambassadorEmail] ?? 0;
});

/** Check if the ambassador has completed the mission. */
export const useAmbassadorMissionCompleted = () => useAppSelector(state => {
    const ambassadorEmail = state.user.email;
    const campaign = state.awareness_campaign.selected.selectedAwarenessCampaign;
    if (!campaign) return false;
    return isCampaignCompleted(campaign, ambassadorEmail);
});
